export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/44328b848c6d3a56c83d85e8cde337fa.jpg"
          alt="VPN Security Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A1F36]/85 via-[#1A1F36]/75 to-[#00D4AA]/60"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
              SECURE YOUR DIGITAL PRIVACY
            </h1>
            <p className="text-xl lg:text-2xl text-gray-200 leading-relaxed">
              Professional VPN solution for complete online protection
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-[#1A1F36] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#252B45] transition-all flex items-center gap-3 whitespace-nowrap"
              >
                <span className="w-8 h-8 bg-[#FF6B35] rounded-full flex items-center justify-center">
                  <i className="ri-lock-line text-white text-lg"></i>
                </span>
                Start Protecting Now
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-[#1A1F36] transition-all whitespace-nowrap"
              >
                Learn More
              </button>
            </div>
          </div>

          <div className="hidden lg:flex justify-center items-center">
            <div className="relative w-full max-w-lg">
              <div className="absolute inset-0 bg-[#00D4AA]/20 rounded-full blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=3D%20isometric%20illustration%20of%20a%20glowing%20shield%20protecting%20a%20digital%20globe%20with%20interconnected%20network%20nodes%2C%20featuring%20turquoise%20and%20white%20accents%20with%20floating%20geometric%20shapes%20representing%20encrypted%20data%20packets%2C%20modern%20cybersecurity%20concept%20art%20with%20soft%20glow%20effects%20and%20clean%20professional%20design%20on%20transparent%20or%20minimal%20background&width=600&height=600&seq=hero-illustration-vpn&orientation=squarish"
                alt="VPN Protection Illustration"
                className="relative w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
